import type { JSX } from 'react'
import type { ILabelProps } from 'atoms/Label'
import type { ILabelGroupProps } from '../LabelGroup'

import {
  LabelInlineSecondaryTemplate,
  QualityLabel,
} from 'atoms/Label/Templates'
import { isQualityResolutionToken } from 'atoms/Label/Templates/qualityBadgeProps'
import { INDENTS } from 'vars/index'
import { LabelGroup } from '../LabelGroup'

export interface ILabelGroupTemplate3Props extends Omit<
  ILabelGroupProps,
  'children'
> {
  list?: ILabelProps['title'][] | null
}

export const LabelGroupTemplate3 = ({
  list,
  columnGap = INDENTS.INDENT_40,
  ...rest
}: ILabelGroupTemplate3Props): JSX.Element => {
  const labels = list?.filter((item) => item) ?? []

  return labels.length > 0 ? (
    <LabelGroup columnGap={columnGap} {...rest}>
      {labels.map((title, i) =>
        isQualityResolutionToken(title) ? (
          <QualityLabel key={`${i}${title}`} title={title} />
        ) : (
          <LabelInlineSecondaryTemplate key={`${i}${title}`} title={title} />
        )
      )}
    </LabelGroup>
  ) : (
    <></>
  )
}
